import React, { useState } from 'react';

const TeamDirectory = ({ currentLanguage, translations }) => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      id: 1,
      name: "Dr. Marcus Weber",
      position: translations?.team?.members?.marcus?.position,
      department: translations?.team?.members?.marcus?.department,
      email: "marcus.weber@rexfel.com",
      phone: "+49 40 123 456 701",
      image: "https://images.unsplash.com/photo-1714974528889-d51109fb6ae9",
      imageAlt: "Professional headshot of middle-aged man with gray hair in dark suit and blue tie",
      expertise: translations?.team?.members?.marcus?.expertise,
      languages: ["German", "English", "French"],
      bio: translations?.team?.members?.marcus?.bio,
      availability: translations?.team?.members?.marcus?.availability,
      specialties: [
        "Venture Capital Strategy",
        "Portfolio Management",
        "European Markets",
        "FinTech Investments"
      ]
    },
    {
      id: 2,
      name: "Sarah Chen",
      position: translations?.team?.members?.sarah?.position,
      department: translations?.team?.members?.sarah?.department,
      email: "sarah.chen@rexfel.com",
      phone: "+49 40 123 456 702",
      image: "https://images.unsplash.com/photo-1734456611474-13245d164868",
      imageAlt: "Professional headshot of Asian woman with long dark hair in navy blazer smiling",
      expertise: translations?.team?.members?.sarah?.expertise,
      languages: ["English", "Mandarin", "German"],
      bio: translations?.team?.members?.sarah?.bio,
      availability: translations?.team?.members?.sarah?.availability,
      specialties: [
        "Investment Analysis",
        "Due Diligence",
        "Financial Modeling",
        "Risk Assessment"
      ]
    },
    {
      id: 3,
      name: "Thomas Müller",
      position: translations?.team?.members?.thomas?.position,
      department: translations?.team?.members?.thomas?.department,
      email: "thomas.mueller@rexfel.com",
      phone: "+49 40 123 456 703",
      image: "https://images.unsplash.com/photo-1597945310606-a54b1774e175",
      imageAlt: "Professional headshot of young man with brown hair in gray suit and white shirt",
      expertise: translations?.team?.members?.thomas?.expertise,
      languages: ["German", "English", "Spanish"],
      bio: translations?.team?.members?.thomas?.bio,
      availability: translations?.team?.members?.thomas?.availability,
      specialties: [
        "Partnership Development",
        "Business Development",
        "Strategic Planning",
        "Market Expansion"
      ]
    },
    {
      id: 4,
      name: "Elena Rodriguez",
      position: translations?.team?.members?.elena?.position,
      department: translations?.team?.members?.elena?.department,
      email: "elena.rodriguez@rexfel.com",
      phone: "+49 40 123 456 704",
      image: "https://images.unsplash.com/photo-1702089050621-62646a2b748f",
      imageAlt: "Professional headshot of Hispanic woman with shoulder-length brown hair in black blazer",
      expertise: translations?.team?.members?.elena?.expertise,
      languages: ["Spanish", "English", "French", "German"],
      bio: translations?.team?.members?.elena?.bio,
      availability: translations?.team?.members?.elena?.availability,
      specialties: [
        "Legal Compliance",
        "Regulatory Affairs",
        "Contract Negotiation",
        "International Law"
      ]
    }
  ];

  const handleContactMember = (member) => {
    // Mock contact action
    window.open(`mailto:${member?.email}?subject=Partnership Inquiry - REXFEL&body=Hello ${member?.name},%0D%0A%0D%0AI would like to discuss a potential partnership opportunity.%0D%0A%0D%0ABest regards`);
  };

  const handleScheduleMeeting = (member) => {
    // Mock scheduling action
    alert(`Scheduling meeting with ${member?.name}. You will be redirected to the calendar booking system.`);
  };

  return null;
};

export default TeamDirectory;